import { useCallback, useEffect, useState, useRef } from "react";
import { api } from "../../utils/api.js";
import { ENDPOINTS as E } from "../../utils/endpoints.js";
import Slider from "../Slider/Slider.js";
import Footer from "../Footer/Footer.js";
import messageService from "../../utils/MessageService.js";
import left from "../../vendor/left.svg";
import right from "../../vendor/right.svg";
import "./RespondSender.css";

function RespondSender({
  isAdmin,
  isModer,
  delay,
  setDelayChanged,
  isDelayChanged,
  autoTurn,
}) {
  const [data, setData] = useState([]);
  const [position, setPosition] = useState(0);
  const [direction, setDirection] = useState(0);
  const [sendedObjects, setSendedObjects] = useState([]);

  const intervalRef = useRef(null);

  const getNotSendCount = useCallback(() => {
    const full = data.map((i) => i.identifier);
    const sended = sendedObjects.map((i) => i.identifier);
    const cleaned = full.filter((i) => !sended.includes(i));
    return cleaned.length;
  }, [data, sendedObjects]);

  const sendMessage = useCallback(
    (el) => {
      const { identifier, ink, ts } = el;
      const role = isAdmin ? 4 : isModer ? 3 : 2;
      const data = [ink, ts, identifier, true, new Date()];
      api
        .post(
          E.MAKE_SENT,
          role,
          { data: data },
          "отклик автоматически отправится при возобновлении подключения"
        )
        .then((res) => {
          if (res.ok || (res.data?.resp === true && res.success === true)) {
            messageService.addSuccessMessage(
              "Отклик успешно помечен отправленным"
            );
          }
          if (res.data?.leaders50?.length) {
            res.data.leaders50.forEach((i) =>
              messageService.addInfoMessage(
                `На этой неделе у компании ИНК-${i.ink} (${i.company}) по вакансии "${i.vacancy}" 50 или более откликов`,
                15000
              )
            );
          }
          if (res.data?.leaders100?.length) {
            res.data.leaders100.forEach((i) =>
              messageService.addErrorMessage(
                `На этой неделе у компании ИНК-${i.ink} (${i.company}) по вакансии "${i.vacancy}" 100 или более откликов`,
                15000
              )
            );
          }
        });
    },
    [isAdmin, isModer]
  );

  function toLeft(event) {
    setDirection(1);
    let newPosition;

    if (position > 0) {
      newPosition = position - 1;
    } else if (event.ctrlKey) {
      newPosition = data.length - 1;
    }

    if (!isNaN(newPosition)) {
      setPosition(newPosition);
    }
  }

  function toRight(event) {
    setDirection(0);
    let newPosition;

    if (position < data.length - 1) {
      newPosition = position + 1;
    } else if (event.ctrlKey) {
      newPosition = 0;
    }

    if (!isNaN(newPosition)) {
      setPosition(newPosition);
    }
  }

  const getData = useCallback(async () => {
    try {
      const role = isAdmin ? 4 : isModer ? 3 : 2;
      const resp = await api.get(E.GET_APPLIES, role);

      if (resp.success && resp.data) {
        const filtered = [];

        if (resp.data.length) {
          resp.data.forEach((item) => {
            if (sendedObjects.some((i) => i.identifier === item.identifier)) {
              sendMessage(item);
            } else {
              filtered.push(item);
            }
          });
        }
        setData(filtered);
      } else {
        setData([]);
      }
    } catch (err) {
      setData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin, isModer, sendMessage, sendedObjects]);

  const changeTimer = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      getData();
    }
    intervalRef.current = setInterval(getData, delay);
  };

  useEffect(() => {
    if (isDelayChanged) {
      changeTimer();
      setDelayChanged(false);
    }
  });

  useEffect(() => {
    getData();
    intervalRef.current = setInterval(getData, delay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="RespondSender">
        <section className="slider-wrapper">
          <div
            className="arrow"
            title={position === 0 ? "Ctrl+click для перехода в конец" : "Назад"}
            onClick={(e) => toLeft(e)}
          >
            <img src={left} className="arrow_icon" alt="Назад" />
          </div>
          <Slider
            shift="692"
            unit="px"
            direction={direction}
            position={position}
            slides={data}
            data={data}
            autoTurn={autoTurn}
            setData={setData}
            sendMessage={sendMessage}
            setSendedObjects={setSendedObjects}
            toRight={toRight}
          />
          <div
            className="arrow"
            title={
              position === data.length - 1
                ? "Ctrl+click для запуска сначала"
                : "Вперёд"
            }
            onClick={(e) => toRight(e)}
          >
            <img src={right} className="arrow_icon" alt="Вперед" />
          </div>
        </section>
      </div>
      <Footer sendedObjects={sendedObjects} getNotSendCount={getNotSendCount} />
    </>
  );
}

export default RespondSender;
